import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getOOOPermissionState } from '../midleware/permisssionReducer';

const usePermission = () => {
  const permission = useSelector(getOOOPermissionState);
  return useMemo(() => ({ permission }), [permission]);
};
export default usePermission;
